import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div id="footer" className="section footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
          <p className="copyright text-center">
            Copyright © 2010-{currentYear} iClipCoupons. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
